<template>
  <v-layout class="wrapper" justify-space-between>
    <v-layout align-center>
      <v-btn
        icon
        style="margin: 0"
        @click="$emit('clear')"
      >
        <v-icon color="white">
          clear
        </v-icon>
      </v-btn>
      <div class="pointer" />
      <div><span class="text">{{ selectionText }}</span></div>
    </v-layout>
    <v-layout justify-end align-center>
      <main-button
        depressed
        :text="adminText('workflowsAll.delete_9485989', 'delete')"
        class="desktop-button"
        @click="$emit('delete')"
      />
      <v-btn icon class="hide" @click="$emit('delete')">
        <v-icon color="white">delete</v-icon>
      </v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'selected-items-header',
  computed: {
    selectionText() {
      const count = this.selected.length
      if (!this.isAdminLocalization) return `${count} ${this.name}${count === 1 ? '' : 's'} selected`
      const lastTwo = count % 100
      const last = count % 10
      const form = last === 1 && lastTwo !== 11 ? 'one' : last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14) ? 'few' : 'other'
      switch (this.name) {
      case 'subscriber':
        switch (form) {
        case 'one':
          return this.adminText('workflowsAll.selection_subscriber_one', '{{count}} subscriber selected', { count })
        case 'few':
          return this.adminText('workflowsAll.selection_subscriber_few', '{{count}} subscribers selected', { count })
        case 'other':
          return this.adminText('workflowsAll.selection_subscriber_other', '{{count}} subscribers selected', { count })
        }
        break
      case 'ticket':
        switch (form) {
        case 'one':
          return this.adminText('workflowsAll.selection_ticket_one', '{{count}} ticket selected', { count })
        case 'few':
          return this.adminText('workflowsAll.selection_ticket_few', '{{count}} tickets selected', { count })
        case 'other':
          return this.adminText('workflowsAll.selection_ticket_other', '{{count}} tickets selected', { count })
        }
        break
      case 'attendee':
        switch (form) {
        case 'one':
          return this.adminText('workflowsAll.selection_attendee_one', '{{count}} attendee selected', { count })
        case 'few':
          return this.adminText('workflowsAll.selection_attendee_few', '{{count}} attendees selected', { count })
        case 'other':
          return this.adminText('workflowsAll.selection_attendee_other', '{{count}} attendees selected', { count })
        }
        break
      case 'email':
        switch (form) {
        case 'one':
          return this.adminText('workflowsAll.selection_email_one', '{{count}} email selected', { count })
        case 'few':
          return this.adminText('workflowsAll.selection_email_few', '{{count}} emails selected', { count })
        case 'other':
          return this.adminText('workflowsAll.selection_email_other', '{{count}} emails selected', { count })
        }
        break
      case 'referral':
        switch (form) {
        case 'one':
          return this.adminText('workflowsAll.selection_referral_one', '{{count}} referral selected', { count })
        case 'few':
          return this.adminText('workflowsAll.selection_referral_few', '{{count}} referrals selected', { count })
        case 'other':
          return this.adminText('workflowsAll.selection_referral_other', '{{count}} referrals selected', { count })
        }
        break
      case 'request':
        switch (form) {
        case 'one':
          return this.adminText('workflowsAll.selection_request_one', '{{count}} request selected', { count })
        case 'few':
          return this.adminText('workflowsAll.selection_request_few', '{{count}} requests selected', { count })
        case 'other':
          return this.adminText('workflowsAll.selection_request_other', '{{count}} requests selected', { count })
        }
        break
      default:
        return this.adminText('workflowsAll.selection_generic', '{{count}} {{name}} selected', { count, name: this.name })
      }

      return this.adminText('workflowsAll.selection_generic', '{{count}} {{name}} selected', { count, name: this.name })
    },
  },
  props: {
    selected: Array,
    name: String,
  },
}
</script>

<style scoped>
  .wrapper {
    color: white;
    margin: 0 0 2px 0;
    padding: 14px 10px;
    background-color: #0277bd;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    height: 56px;
    position: relative;
  }
  .text {
    font-family: Raleway;
    font-size: 16px;
    font-weight: bold;
  }
  .pointer {
    position: relative;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #0277bd;
    top: 30px;
    right: 30px;
  }
</style>
